import { FocusEventHandler } from "react";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import AsyncSelect from "react-select/async";

type InputFieldProps = {
  setValue: Function;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  value?: string | string[];
  placeholder: string;
  type: string;
  name: string;
  label: string;
  className?: string;
  styles?: any;
  required?: boolean
};

export default function InputField({
  setValue,
  value,
  placeholder,
  type,
  name,
  label,
  onBlur,
  className,
  required = false,
}: InputFieldProps) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <input
        name={name}
        type={type}
        className={className}
        placeholder={placeholder}
        onChange={(event) => setValue(event.target.value)}
        value={value}
        onBlur={onBlur}
        required={required}
      />
    </>
  );
}

export function TextArea({
  setValue,
  value,
  placeholder,
  name,
  label,
  className,
  required = false
}: InputFieldProps) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <textarea
        name={name}
        className={className}
        placeholder={placeholder}
        onChange={(event) => setValue(event.target.value)}
        value={value}
        rows={7}
        // onBlur={onBlur}
        required={required}
      />
    </>
  );
}

export function SelectField({
  setValue,
  value,
  placeholder,
  name,
  label,
  options,
        required=false
  
}: InputFieldProps & { options: { [key: string]: string }[] }) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <Select
        name={name}
        placeholder={placeholder}
        onChange={(val) => setValue(val)}
        value={value}
        styles={{
          option: (styles) => {
            return {
              ...styles,
              color: "#7d7d7d",
              ":active": {
                ...styles[":active"],
                option: {
                  color: "#000",
                },
              },
            };
          },
        }}
        // @ts-ignore
        options={options.map((opt) => ({
          key: opt.value,
          label: opt.label,
          value: opt.value,
        }))}
        required={required}
      />
    </>
  );
}

export function MultiSelectField({
  setValue,
  value,
  placeholder,
  name,
  label,
  options,
}: InputFieldProps & {
  value: { [key: string]: string }[] | string;
  options: { [key: string]: string }[];
}) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <Select
        name={name}
        // className="select-box"
        isMulti
        placeholder={placeholder}
        onChange={(newValue) => setValue(newValue)}
        // @ts-ignore
        value={value}
        // @ts-ignore
        options={options}
        styles={{
          option: (styles) => {
            return {
              ...styles,
              color: "#7d7d7d",
              ":active": {
                ...styles[":active"],
                option: {
                  color: "#000",
                },
              },
            };
          },
        }}
      />
    </>
  );
}

export function AsyncMultiSelectField({
  setValue,
  placeholder,
  name,
  label,
  loadOptions,
  value,
  maxSelection = 8,
  loadingMessage,
  noOptionsMessage,
  isLoading,
  styles = {},
}: InputFieldProps & {
  value?: any;
  loadOptions?:
    | ((
        inputValue: string,
        callback: (
          options: OptionsOrGroups<unknown, GroupBase<unknown>>
        ) => void
      ) => void)
    | ((
        inputValue: string
      ) => Promise<OptionsOrGroups<unknown, GroupBase<unknown>>>)
    | undefined;
  isLoading?: boolean;
  loadingMessage?: string;
  noOptionsMessage?: string;
  maxSelection: number;
}) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <AsyncSelect
        name={name}
        isMulti
        value={value}
        placeholder={placeholder}
        onChange={(newValue, action) => setValue(newValue, action)}
        loadOptions={loadOptions}
        isLoading={isLoading}
        isOptionDisabled={() => value!.length >= maxSelection}
        isClearable={value!.length >= maxSelection}
        loadingMessage={() => <>{loadingMessage}</>}
        noOptionsMessage={
          noOptionsMessage ? () => <>{noOptionsMessage}</> : undefined
        }
        styles={{
          ...styles,
          ...{
            option: (stylez) => {
              return {
                ...stylez,
                color: "#7d7d7d",
                ":active": {
                  ...stylez[":active"],
                  option: {
                    color: "#000",
                  },
                },
              };
            },
          },
        }}
      />
    </>
  );
}
